module.exports = __webpack_public_path__ + "img/dox-registration-success-nodox-loop.880fe18b.gif";